<template>
  <section class="bg-tw-cream" aria-labelledby="steps-heading">
    <div class="mx-auto max-w-[1280px] px-6 py-20 md:px-[94px] md:pb-[70px] md:pt-[106px]">
      <p class="inline-block bg-tw-rust px-1 text-[17px] font-semibold uppercase leading-7 text-white">{{ t('eyebrow') }}</p>
      <h2 id="steps-heading" class="mt-8 max-w-[546px] text-4xl tracking-[-0.02em] text-black md:text-[45px] md:leading-[1.2]">{{ t('heading') }}</h2>
      <p class="mt-8 max-w-[519px] text-xl leading-7 text-tw-ink md:text-[25px]">{{ t('lead') }}</p>
      <ol class="mt-10 grid gap-x-7 md:grid-cols-2">
        <li v-for="n in 4" :key="n" class="flex gap-6 border-t border-black py-10 md:min-h-[210px]">
          <span class="w-12 shrink-0 text-center text-3xl font-medium tracking-[-0.02em] text-tw-rust" aria-hidden="true">0{{ n }}</span>
          <div class="max-w-[370px] text-tw-ink">
            <h3 class="text-2xl leading-7 md:text-[28px]">{{ t(`step${n}.title`) }}</h3>
            <p class="mt-5 text-lg leading-8 md:text-xl">{{ t(`step${n}.text`) }}</p>
          </div>
        </li>
      </ol>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n({
    messages: {
      no: {
        eyebrow: 'Fra spørsmål til felles forståelse',
        heading: 'Hvordan skape gode læringssamtaler',
        lead: 'Fire steg for å få flere med i klasserommet eller på forelesningen.',
        step1: { title: 'Still et åpent spørsmål', text: 'Inviter til tenking og utforsking, med rom for ulike svar.' },
        step2: {
          title: 'La alle tenke og skrive',
          text: 'Be alle dele et kort svar. De deltar med kallenavn og PIN-kode eller logger inn med Feide.',
        },
        step3: { title: 'Utforsk ideene sammen', text: 'La deltakerne spørre, utdype og utfordre hverandres ideer.' },
        step4: { title: 'Oppsummer og se videre', text: 'Hva har dere lært? Hva er uklart, og hva vil dere utforske videre?' },
      },
      en: {
        eyebrow: 'From questions to shared understanding',
        heading: 'How to create good learning conversations',
        lead: 'Four steps to get more people involved in the classroom or lecture hall.',
        step1: { title: 'Ask an open question', text: 'Invite thinking and exploration, with room for different answers.' },
        step2: {
          title: 'Let everyone think and write',
          text: 'Ask everyone to share a short answer. They join with a nickname and PIN code, or log in with Feide.',
        },
        step3: { title: 'Explore the ideas together', text: "Let participants question, elaborate on and challenge each other's ideas." },
        step4: { title: 'Sum up and look ahead', text: 'What have you learned? What is unclear, and what do you want to explore further?' },
      },
    },
  })
</script>
